export const CLAIMS_MODULOS = {
  CURADORIA: 'Curadoria',
  INDICADORES: 'Indicadores',
  INDICADORES_MURALHA: 'Indicadores do Muralha',
  ADMIN_PERFIL: 'Administração de perfil',
  CADASTRO_PERFIL: 'Cadastro de perfil',
  ADMIN_USUARIOS: 'Administração de Usuários',
  FILTROS_PERSONALIZADOS: 'Filtros personalizados',
  LOGS: 'Logs do sistema',
  REGRAS_ALERTAS: 'Regras de alertas',
  DASHBOARD: 'Dashboard',
  ANALISE_TEMPORAL: 'Análise Temporal'
} as const;

export const CLAIMS_PERMISSOES = {
  CURADORIA: {
    VISUALIZAR: 'Botão Visível no menu',
  },

  INDICADORES: {
    UNIDADE_CADASTRO: 'Ver apenas unidade de cadastro',
    VISUALIZAR: 'Botão Visível no menu',
    FILTROS: 'Filtros',
    VER_TODAS_UNIDADES: 'Ver todas as Unidades',
  },

  INDICADORES_MURALHA: {
    VISUALIZAR: 'Botão Visível no Menu',
    FILTROS: 'Filtros',
  },

  ADMIN_PERFIL: {
    GESTAO_SUB_PERFIS: 'Gestão dos sub perfis',
    EXCLUIR: 'Excluir perfil',
    EDITAR: 'Editar perfil',
    VISUALIZAR: 'Botão Visível no menu',
  },

  CADASTRO_PERFIL: {
    VISUALIZAR: 'Botão Visível no menu',
  },

  CADASTRO_PERFIL_PERMISSAO: {
    VISUALIZAR: 'Botão Visível no Menu',
    FILTROS: 'Filtros',
    VER_TODAS_UNIDADES: 'Ver todas as Unidades',
    UNIDADE_CADASTRO: 'Ver apenas unidade de cadastro',
  },

  LOGS_SISTEMA: {
    VISUALIZAR: 'Botão Visível no menu',
  },

  REGRAS_ALERTAS: {
    VISUALIZAR: 'Botão Visível no menu',
  },

  ADMIN_USUARIOS: {
    VISUALIZAR_USUARIO: 'Visualizar usuários',
    EDITAR: 'Editar usuários',
    VISUALIZAR: 'Botão Visível no menu',
    HISTORICO: 'Acesso ao Histórico',
  },

  FILTROS_PERSONALIZADOS: {
    CRIAR: 'Criação de perfis personalizados',
    EDITAR: 'Editar perfil personalizado',
    VISUALIZAR: 'Botão Visível no menu',
    VISUALIZAR_PERFIL: 'Visualizar perfis personalizados',
    EXCLUIR: 'Excluir perfis personalizados',
  },

  DASHBOARD: {
    HISTORICO_BO: 'Ver Histórico Completo do BO',
    VISUALIZAR: 'Botão Visível no menu',
    UNIDADE_CADASTRO: 'Ver apenas unidade de cadastro',
    FILTROS: 'Filtros',
    VER_ALERTAS: 'Ver Alertas e Áreas Criticas',
    VER_TODAS_UNIDADES: 'Ver todas as Unidades',
  },

  ANALISE_TEMPORAL: {
    VISUALIZAR: 'Botão Visível no menu',
  }
} as const;
